import React, { useEffect, useState, useRef } from "react";
import apiDefinitions from "../../../../api/apiDefinitions";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import { Link } from "react-router-dom";
import { Pagination, Form } from "react-bootstrap";
import {
  priority,
  status,
} from "../../../../core/common/selectoption/selectoption";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ExpenseApproval = () => {
  const hasDataLoaded = useRef(false);
  const route = all_routes;
  const navigate = useNavigate();

  const [employeeId, setEmployeeId] = useState(7);
  const [searchKey, setSearchKey] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [leadStatus, setLeadStatus] = useState("");
  const [leadPriority, setLeadPriority] = useState("");
  const [leadId, setLeadId] = useState<number | null>(null);
  const [fullName, setFullName] = useState("");
  const [assignedBy, setAssignedBy] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [employeeList, setEmployeeList] = useState<any[]>([]);
  const [description, setDescription] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [refresh, setRefresh] = useState(false);

  const [isNoteValid, setIsNoteValid] = useState(false);

  const [allLeads, setAllLeads] = useState<Lead[]>([]); // Store all fetched leads
  const [leads, setLeads] = useState<Lead[]>([]); // Store the current page's leads
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  interface DecodedToken {
    exp: number;
    [key: string]: any;
  }

  interface Lead {
    id: number;
    amount: number;
    campaignId: string;
    campaignName: number;
    expenseTypeName: string;
    typeReason: string;
    approveStatusName: string;
  }

  interface FetchLeadsResponse {
    content: Lead[];
    totalElements: number;
    totalPages: number;
  }

  const fetchLeads = async (): Promise<void> => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    if (hasDataLoaded.current) return; // Prevent duplicate fetching
    hasDataLoaded.current = true;

    const loadingToastId = toast.loading("Loading Expenses...");

    try {
      const response = await apiDefinitions.getAllPendingExpenses(token);
      const data = response.data;

      if (data && data.data) {
        toast.dismiss(loadingToastId);
        setAllLeads(data.data);
        setTotalPages(Math.ceil(data.data.length / itemsPerPage));
        setLeads(data.data.slice(0, itemsPerPage)); // Load the first page
      } else {
        toast.dismiss(loadingToastId);
        console.error("Invalid response format:", data);
      }
    } catch (error) {
      console.error("Failed to fetch leads", error);
    }
  };

  useEffect(() => {
    fetchLeads(); // Fetch leads only once when the component mounts
  }, []);

  useEffect(() => {
    // Update the displayed leads when the current page or items per page changes
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setLeads(allLeads.slice(startIndex, endIndex));
  }, [currentPage, itemsPerPage, allLeads]);

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleItemsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const items = parseInt(event.target.value, 10);
    setItemsPerPage(items);
    setCurrentPage(1); // Reset to the first page when items per page changes
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        fetchLeads();
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    console.log("Current page:", currentPage);
  }, [currentPage]);

  const handleSearch = () => {
    setSearchClicked(!searchClicked);
  };

  const handleClose = () => {
    setSearchClicked(!searchClicked);
    setSearchKey("");
  };

  const handleAssignLead = (leadId: number) => {
    setLeadId(leadId);
  };

  const handleSubmit = () => {
    let isValid = true;
    if (!description) {
      isValid = false;
      setIsNoteValid(true);
    } else {
      setIsNoteValid(false);
    }

    if (!isValid) {
      console.error("Form validation failed.");
      return; // Stop execution if validation fails
    }
    console.log("Submitted");
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }
    if (isValid) {
      Swal.fire({
        title: "Do You Want To Submit?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Save",
        denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }
          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);
            if (decodedToken.exp && decodedToken.exp > currentTime) {
              apiDefinitions
                .campaignExpensesApproval(
                  token,
                  leadId,
                  approvalStatus,
                  description
                )
                .then((response: any) => {
                  const data = response.data.data;
                  console.log("Lead Data By ID: ", data);
                  setRefresh(!refresh);
                  // Close the modal
                  // const modalElement = document.getElementById("add_faq");
                  // if (modalElement) {
                  //   modalElement.classList.remove("show");
                  //   modalElement.style.display = "none";
                  //   const backdrop = document.querySelector(".modal-backdrop");
                  //   if (backdrop) {
                  //     backdrop.remove();
                  //   }
                  // }
                  window.location.reload();
                  // Show success Swal
                  Swal.fire({
                    icon: "success",
                    title: "Approval Submitted Successfully!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                })
                .catch((error) => {
                  console.error("Error approving lead:", error);
                  Swal.fire({
                    icon: "error",
                    title: "Failed to Save Changes",
                    text: "An error occurred while saving changes. Please try again.",
                  });
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate("/login");
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        } else {
          // Show toast for not saving
          toast("Changes Were Not Saved", {
            icon: "⚠️",
          });
        }
      });
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getMarketingEmployeeList().then((response: any) => {
          console.log("Course Categories: ", response.data.data);
          setEmployeeList(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <div className="card-title">Expenses Approval</div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <Form.Select
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                        aria-label="Select number of items per page"
                        className="w-auto"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </Form.Select>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table text-nowrap table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Campaign Name</th>
                            <th scope="col">Expense Type</th>
                            <th scope="col">Expense Name</th>
                            <th scope="col">Expense Ammount(Rs.)</th>
                            <th scope="col">Approval Status</th>

                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {leads.map((lead, index) => (
                            <tr key={index}>
                              <td>{lead.campaignName}</td>
                              <td>{lead.expenseTypeName}</td>
                              <td>{lead.typeReason}</td>
                              <td>{lead.amount}</td>
                              <td>
                                <span className="badge bg-soft-secondary">
                                  {lead.approveStatusName}
                                </span>
                              </td>
                              <td>
                                <div className="hstack gap-2 fs-15">
                                  <Link
                                    to="#"
                                    className="btn btn-info"
                                    data-bs-toggle="modal"
                                    data-bs-target="#add_faq"
                                    onClick={() => {
                                      handleAssignLead(lead.id);
                                    }}
                                  >
                                    <i
                                      className="feather-check-circle"
                                      style={{ fontSize: "17px" }}
                                    />
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <Pagination className="mt-3 justify-content-center">
                      <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      />
                      {Array.from({ length: totalPages }, (_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_faq" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Expenses Approval</h5>
              <div className="d-flex align-items-center mod-toggle">
                <button
                  className="btn-close custom-btn-close border p-1 me-0 text-dark"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
            </div>
            <form>
              <div className="modal-body">
                <div className="mb-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Lead Priority Level
                  </label>
                  <select
                    className={`form-select`}
                    id="validationCustomContactMethod"
                    value={approvalStatus}
                    onChange={(e) => setApprovalStatus(e.target.value)}
                    required
                  >
                    <option value="">Select an option</option>
                    <option value="approved">Approve </option>
                    <option value="rejected">Reject</option>
                  </select>
                </div>

                {approvalStatus === "rejected" && (
                  <div className="mb-3">
                    <label
                      className="form-label"
                      htmlFor="validationCustomContactMethod"
                    >
                      Approval Note
                    </label>
                    <textarea
                      rows={1}
                      cols={5}
                      className={`form-control ${
                        isNoteValid ? "is-invalid" : ""
                      }`}
                      placeholder="Enter text here"
                      defaultValue={""}
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                    />
                    {isNoteValid && (
                      <div className="invalid-feedback">
                        Please enter a description.
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <div className="d-flex align-items-center justify-content-end m-0">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    // data-bs-dismiss="modal"
                    className="btn btn-primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseApproval;
